import { render, staticRenderFns } from "./AdminListingStatusBadge.vue?vue&type=template&id=507e00c1"
import script from "./AdminListingStatusBadge.vue?vue&type=script&lang=js"
export * from "./AdminListingStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507e00c1')) {
      api.createRecord('507e00c1', component.options)
    } else {
      api.reload('507e00c1', component.options)
    }
    module.hot.accept("./AdminListingStatusBadge.vue?vue&type=template&id=507e00c1", function () {
      api.rerender('507e00c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminListingStatusBadge.vue"
export default component.exports